import { AnalyticsManager } from './AnalyticsManager';
import { MatomoAnalyticsProvider } from './providers/matomo/MatomoAnalyticsProvider';

// Создаем глобальный экземпляр менеджера аналитики
export const analyticsManager = new AnalyticsManager();

// Функция для инициализации провайдеров
export const initializeAnalytics = () => {
    if (!analyticsManager.enabled()) return;

    // Инициализация Matomo
    const matomoProvider = new MatomoAnalyticsProvider();
    analyticsManager.addProvider(matomoProvider);

    // Здесь можно добавить другие провайдеры в будущем
    // const googleAnalyticsProvider = new GoogleAnalyticsProvider();
    // analyticsManager.addProvider(googleAnalyticsProvider);
};

// Экспорт всех необходимых компонентов
export { AnalyticsManager } from './AnalyticsManager';
export { AnalyticsProvider } from './context/AnalyticsProvider';
export { PageViewTracker } from './trackers/PageViewTracker';
export { useAnalytics } from './hooks/useAnalytics';
export { getMatomoInstance } from './helpers/matomoHelper';
export type { AnalyticsProvider as IAnalyticsProvider, AnalyticsEvent, PageViewEvent } from './types/analytics.types';
